export { Provider, atom } from 'jotai';
export type { Getter, Setter } from 'jotai';

export * from './store';
export * from './useAtom';
